import { InvalidArgumentError } from '../../../@harmony';

/**
 * Isomorphic Firestore document
 * Compatible with `firebase` (client) and `firebase-admin` (cloud function).
 */
export interface IsoDoc<T> {
  id: string;
  data(): T | undefined;
}

export interface PrivateTimestampDto {
  readonly _seconds: number;
  readonly _nanoseconds: number;
}

export interface TimestampDto {
  readonly seconds: number;
  readonly nanoseconds: number;
}

/**
 * Isomorphic Firestore timestamp
 * Compatible with `firebase` (client) and `firebase-admin` (cloud function).
 */
export interface IsoTimestamp extends TimestampDto {
  toDate(): Date;
  toMillis(): number;
  isEqual(other: IsoTimestamp): boolean;
  valueOf(): string;
}

/** Similar to `Partial<T>` but adds `null` as possible value */
export type FirestorePartial<T> = {
  [P in keyof T]?: T[P] | null;
};

export class FirestoreEntity<T> {
  constructor(
    public readonly id: string,
    public readonly data: T,
  ) {}

  static from<T = unknown>(doc: IsoDoc<T>): FirestoreEntity<T> {
    const data = doc.data();

    if (!data) {
      throw new InvalidArgumentError('The provided document is empty');
    }

    return { id: doc.id, data };
  }
}
